import { ClerkProvider } from "@clerk/clerk-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";

import { ThemeProvider } from "@/contexts/ThemeContext";
import { config } from "@/lib/config";
import { queryClient } from "@/lib/query-client";
import "@/styles/index.css";
import { App } from "./App.tsx";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

const DEV_BYPASS = import.meta.env["VITE_DEV_AUTH_BYPASS"] === "true";

const toasterProps = {
  position: "top-right" as const,
  toastOptions: {
    duration: 4000,
    style: {
      background: "rgb(var(--color-background-secondary))",
      color: "rgb(var(--color-text-primary))",
      border: "1px solid rgb(var(--color-border))",
      borderRadius: "0.5rem",
      fontSize: "0.875rem",
    },
    success: {
      iconTheme: {
        primary: "rgb(var(--color-success))",
        secondary: "rgb(var(--color-background-secondary))",
      },
    },
    error: {
      iconTheme: {
        primary: "rgb(var(--color-error))",
        secondary: "rgb(var(--color-background-secondary))",
      },
    },
  },
};

const inner = (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
      <Toaster {...toasterProps} />
    </BrowserRouter>
    {config.isDevelopment && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider>
      {DEV_BYPASS ? (
        inner
      ) : (
        <ClerkProvider publishableKey={config.clerkPublishableKey}>
          {inner}
        </ClerkProvider>
      )}
    </ThemeProvider>
  </React.StrictMode>
);
